import { getServicesRequestInterface } from 'www/modules/Schedule/models'
import type { getServicesItemInterface } from 'www/modules/Schedule/models/item'
import type { getServicesStorageInterface } from 'www/modules/Schedule/models/storage'
import type {
  ServiceRequestItem,
  ServicesRequestInterface,
} from 'www/modules/Schedule/models/request'

type ServicesItemData = ReturnType<typeof getServicesItemInterface> & {
  coverNode?: HTMLElement
  scheduleNode?: HTMLElement
  scheduleNodeHTML?: string
}

type ServicesScheduleData = {
  items: Map<HTMLElement, ServicesItemData>
  storage: ReturnType<typeof getServicesStorageInterface>
}

/**
 * @description
 * Собирает данные для запроса за расписанием для услуг
 *
 * @param opts.data - данные 'ScheduleData'
 * @param opts.servicesPart - список с [{ lpu_id, service_id }], аналогичный, который собирается в переменной 'services', просто собран вручную
 * Используется при выборе услуги для запроса расписания только для 1 клиники. Если это поле передано - у него приоритет перед переменной 'services'
 *
 * @returns объект в формате 'getServicesRequestInterface'
 */

const getServicesRequestData = ({
  data,
  servicesPart = [],
}: {
  data: ServicesScheduleData
  servicesPart?: ServiceRequestItem[]
}): ServicesRequestInterface => {
  const baseData = getServicesRequestInterface()
  const { dateStart, timedelta } = data.storage
  const services = servicesPart.length
    ? servicesPart
    : [...data.items].map(([scheduleContainer, itemData]): ServiceRequestItem | undefined => {
      const {
        lpuId,
        synonymPreview,
        serviceIsDirect,
        serviceIsExpress,
        serviceIsAvailable,
      } = itemData

      if (!synonymPreview) {
        return undefined
      }

      const { hasIntervals, id: serviceId } = synonymPreview
      const isExpressOrDirect = serviceIsDirect || serviceIsExpress
      const hasEveryNeedData = serviceId && hasIntervals && scheduleContainer && serviceIsAvailable

      if (!hasEveryNeedData || !serviceId) {
        return undefined
      }

      if (!isExpressOrDirect) {
        return undefined
      }

      return {
        lpu_id: lpuId,
        service_id: serviceId,
      }
    })

  baseData.day_start = dateStart
  baseData.town_timedelta = timedelta
  baseData.services = services.filter((i): i is ServiceRequestItem => Boolean(i))

  return baseData
}

export default getServicesRequestData
